import { Component, Vue } from 'vue-property-decorator';
import WithRender from './referral.html';
import VuePhoneNumberInput from "vue-phone-number-input";
import config from '@/settings/config.js';
import _axios from '@/services/axios';
import Loading from 'vue-loading-overlay';


@WithRender
@Component({
  components: {
    VuePhoneNumberInput,
    Loading
  }
})
export default class Referral extends Vue {

  selectedFile: any = null;
  mobileNumber = '';
  isLoading = false;
  form = {
    name: '',
    mobile: '',
    address: '',
    postalcode: '',
    provice: ''
  }
  options = [
    { value: "Eastern Cape", text: 'Eastern Cape' },
    { value: "Free State", text: "Free State" },
    { value: "Gauteng", text: "Gauteng" },
    { value: "KwaZulu-Natal", text: "KwaZulu-Natal" },
    { value: "Limpopo", text: "Limpopo" },
    { value: "Mpumalanga", text: "Mpumalanga" },
    { value: "Northern Cape", text: "Northern Cape" },
    { value: "North West", text: "North West" },
    { value: "Western Cape", text: "Western Cape" },
  ]
  valideReceiverNumberMessage = '';

  onFileChanged(event: any) {
    this.selectedFile = event.target.files[0];
  }

  ValidatePhoneNumber(payload: any) {
    if (payload.isValid) {
      this.valideReceiverNumberMessage = '';
      this.form.mobile = payload.countryCallingCode + payload.nationalNumber;
    } else {
      this.valideReceiverNumberMessage = "Please make sure mobile number is valid!";
    }
  }

  onSubmit(event: any) {
    event.preventDefault()
    this.isLoading = true;
    const formData = new FormData();
    if (this.selectedFile != null)
      formData.append("image", this.selectedFile, this.selectedFile.name);
    formData.append("fullName", this.form.name);
    formData.append("mobile", this.form.mobile);
    formData.append("isAgent", 'true');
    formData.append("address", this.form.address);
    formData.append("postalCode", this.form.postalcode);
    formData.append("province", this.form.provice);

    _axios.post(config.gateway + "customerdata/user/referral", formData,
      {
        onUploadProgress: (progressEvent) => {
          console.log(progressEvent.loaded / progressEvent.total);
        },
      })
      .then((response) => {
        this.$router.push("callback?msg=" + response.data);
      })
      .catch((error) => {
        const err = error as any;
        if (err.response && err.response.status && err.response.status == '400')
          this.ErrorNotification(err.response.data, 'danger');
        else
          this.ErrorNotification("please check that you have data or your internet connection is on.", 'danger');
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  private ErrorNotification(message: string, type: string) {
    this.$bvToast.toast(message, {
      title: 'Notification',
      variant: type,
      autoHideDelay: 5000,
    });
  }
}
